import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/branch'
        title='Branch Management'
        icon='book-open'
        fontIcon='bi-person'
      ></SidebarMenuItem>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Restaurant</span>
        </div>
      </div>

      <SidebarMenuItem
        to='/foodmenu'
        title='Food Menu'
        icon='coffee'
        fontIcon='bi-person'
      ></SidebarMenuItem>

      <SidebarMenuItem
        to='/categories/main'
        title='Categories'
        fontIcon='bi-archive'
        icon='element-plus'
      ></SidebarMenuItem>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Online</span>
        </div>
      </div>
      <SidebarMenuItem to='/Orders' icon='handcart' title='Orders' fontIcon='bi-chat-left' />
      <SidebarMenuItem
        to='/TransactionTable'
        icon='bill'
        title='Transaction'
        fontIcon='bi-layers'
      />
    </>
  )
}

export {SidebarMenuMain}
